import { render, staticRenderFns } from "./social-clubs-container.vue?vue&type=template&id=201ffae7&scoped=true&lang=pug"
import script from "./social-clubs-container.js?vue&type=script&lang=js&external"
export * from "./social-clubs-container.js?vue&type=script&lang=js&external"
import style0 from "./social-clubs-container.vue?vue&type=style&index=0&id=201ffae7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201ffae7",
  null
  
)

export default component.exports